/*!

=========================================================
* Argon Dashboard PRO React - v1.2.5
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState } from "react";
// nodejs library that concatenates classes
import classnames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// reactstrap components
import {
  Collapse,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  ListGroupItem,
  ListGroup,
  Media,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
  Button,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import { useAuth } from "context/AuthContext";
import Breadcrumbs from "components/BreadCrumb/Breadcrumbs";
import { updateUser } from "actions/users";

function AdminNavbar({ theme, sidenavOpen, toggleSidenav, brandText }) {
  // function that on mobile devices makes the search open
  const { logout } = useAuth();
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const data = JSON.parse(localStorage.getItem("p"));
  const userName = data?.name;
  const localStorageData = JSON.parse(localStorage.getItem("p"));
  const openSearch = () => {
    document.body.classList.add("g-navbar-search-showing");
    setTimeout(function () {
      document.body.classList.remove("g-navbar-search-showing");
      document.body.classList.add("g-navbar-search-show");
    }, 150);
    setTimeout(function () {
      document.body.classList.add("g-navbar-search-shown");
    }, 300);
  };
  // function that on mobile devices makes the search close
  const closeSearch = () => {
    document.body.classList.remove("g-navbar-search-shown");
    setTimeout(function () {
      document.body.classList.remove("g-navbar-search-show");
      document.body.classList.add("g-navbar-search-hiding");
    }, 150);
    setTimeout(function () {
      document.body.classList.remove("g-navbar-search-hiding");
      document.body.classList.add("g-navbar-search-hidden");
    }, 300);
    setTimeout(function () {
      document.body.classList.remove("g-navbar-search-hidden");
    }, 500);
  };
  const navigate = useNavigate();

const handleLogout = async () => {
  setIsLoggingOut(true);
  try {
    // const res = await logout();
    
    if (localStorageData.loginAs === "PUBLISHER") {
      // Get admin data from p1
      const adminData = localStorage.getItem('p1');
      
      if (adminData) {
        // Clear everything
        localStorage.clear();
        
        // Restore admin data as p
        localStorage.setItem('p', adminData);
        // localStorage.setItem('loginAs', 'ADMIN');
        
        // Force complete page reload to admin dashboard
        // This ensures all contexts reinitialize with new data
        window.location.replace("/admin/dashboard");
      } else {
        // No admin data found
        localStorage.clear();
        window.location.replace("/auth/login");
      }
    } else {
      // Normal admin logout
      localStorage.clear();
      window.location.replace("/auth/login");
    }
    
    setIsLoggingOut(false);
  } catch (error) {
    // Error case
    localStorage.clear();
    window.location.replace("/auth/login");
    setIsLoggingOut(false);
  }
};
  return (
    <>
      {/* <Navbar
        className={classnames(
          "navbar-top navbar-expand",
          theme === "dark"
            ? brandText === "Dashboards"
              ? "navbar-dark bg-gradient-info pb--7"
              : "navbar-dark bg-gradient-info pb-7"
            : "navbar-light bg-secondary",
        )}
      > */}
      <Navbar
        className={classnames(
          "navbar-top navbar-expand",
          theme === "dark"
            ? brandText === "Dashboards"
              ? "navbar-dark pb--7"
              : "navbar-dark pb-7"
            : "navbar-light bg-secondary",
        )}
        style={theme === "dark" ? { backgroundColor: "#0C0C0C" } : {}}
      >
        <div className="navbar-geometric">
          <div className="nav-square square-1"></div>
          <div className="nav-square square-2"></div>
          {/* <div className="nav-square square-3"></div> */}
          {/* <div className="nav-circle"></div> */}
        </div>
        <Container fluid>
          <Collapse navbar isOpen={true}>
            <Form
              className={classnames(
                "navbar-search form-inline mr-sm-3",
                { "navbar-search-light": theme === "dark" },
                { "navbar-search-dark": theme === "light" },
              )}
            >
              <button
                aria-label="Close"
                className="close"
                type="button"
                onClick={closeSearch}
              >
                <span aria-hidden={true}>×</span>
              </button>
           
            </Form>
            <Nav className="align-items-center ml-md-auto" navbar>
                        {localStorageData.loginAs === "PUBLISHER" && (<Button  size="sm"
            className="btn-gradient-primary d-flex align-items-center" onClick={handleLogout}>Back to Admin</Button>)}
              <NavItem className="d-xl-none">
                <div
                  className={classnames(
                    "pr-3 sidenav-toggler",
                    { active: sidenavOpen },
                    { "sidenav-toggler-dark": theme === "dark" },
                  )}
                  onClick={toggleSidenav}
                >
                  <div className="sidenav-toggler-inner">
                    <i className="sidenav-toggler-line" />
                    <i className="sidenav-toggler-line" />
                    <i className="sidenav-toggler-line" />
                  </div>
                </div>
              </NavItem>
              <NavItem className="d-sm-none">
                <NavLink onClick={openSearch}>
                  <i className="ni ni-zoom-split-in" />
                </NavLink>
              </NavItem>
              <UncontrolledDropdown nav>
                {/* <DropdownToggle className="nav-link" color="" tag="a">
                  <i className="ni ni-bell-55" />
                </DropdownToggle> */}
              </UncontrolledDropdown>

            </Nav>
            <Nav className="align-items-center ml-auto ml-md-0" navbar>
              <NavItem className="d-flex align-items-center">
                {/* USER NAME (NOT CLICKABLE) */}
                {/* THREE DOT MENU */}
                <UncontrolledDropdown nav>
                  <DropdownToggle
                    className="nav-link p-0"
                    color=""
                    tag="span"
                    style={{ cursor: "pointer" }}
                  >
                    <span className="mb-0 text-sm font-weight-bold mr-2 text-white">
                      {userName}
                    </span>
                    <i className="fa fa-ellipsis-v text-white" />
                  </DropdownToggle>

                  <DropdownMenu right>
                    <DropdownItem className="noti-title" header tag="div">
                      <h6 className="text-overflow m-0">Welcome!</h6>
                    </DropdownItem>

                    <DropdownItem onClick={() => navigate("/admin/profile")}>
                      <i className="ni ni-single-02" />
                      <span>My profile</span>
                    </DropdownItem>

                    {/* <DropdownItem>
                      <i className="ni ni-settings-gear-65" />
                      <span>Settings</span>
                    </DropdownItem>

                    <DropdownItem>
                      <i className="ni ni-calendar-grid-58" />
                      <span>Activity</span>
                    </DropdownItem>

                    <DropdownItem>
                      <i className="ni ni-support-16" />
                      <span>Support</span>
                    </DropdownItem> */}

                    <DropdownItem divider />

                    <DropdownItem
                      onClick={handleLogout}
                      disabled={isLoggingOut}
                    >
                      <i className="fa fa-sign-out" />
                      <span>{isLoggingOut ? "Logging out..." : "Logout"}</span>
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </NavItem>
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
    </>
  );
}

AdminNavbar.defaultProps = {
  toggleSidenav: () => { },
  toggleSidenav: () => { },
  sidenavOpen: false,
  theme: "dark",
};
AdminNavbar.propTypes = {
  toggleSidenav: PropTypes.func,
  sidenavOpen: PropTypes.bool,
  theme: PropTypes.oneOf(["dark", "light"]),
};

export default AdminNavbar;
